import React from 'react';
import Marquee from 'react-fast-marquee';

const AlertNotification = () => {
  return (
    <div className="bg-[var(--marquee-bg)] z-[1000] lg:fixed h-[28px] w-full flex items-center top-[125px] lg:top-[67.5px]">
      <div className="container-fluid">
        <Marquee speed={50} pauseOnHover pauseOnClick className="h-[28px] scrollbar-hide">
          <span className="flex items-center h-[28px] text-[12px] font-bold leading-[30px] text-headerText">
            Welcome to RS Play • Latest updates available now • Check out the newest features •
          </span>

          <span className="mx-8 flex items-center h-[28px] text-[12px] font-bold leading-[30px] text-headerText">
            Welcome to RS Play • Latest updates available now • Check out the newest features •
          </span>
        </Marquee>
      </div>
    </div>
  );
};

export default AlertNotification;
